import { ewent, observe } from "../reactive";
export class ExpansionBehaviour {
    constructor(starts_collapsed) {
        this.collapsed_event = ewent();
        this.expanded_event = ewent();
        this.collapsed = observe(starts_collapsed);
    }
    isCollapsed() {
        return this.collapsed.value();
    }
    isExpanded() {
        return !this.collapsed.value();
    }
    bindToClickable(widget) {
        widget.on("click", (e) => {
            e.stopPropagation();
            this.toggle();
        });
        return this;
    }
    toggle() {
        if (this.collapsed.value())
            this.expand();
        else
            this.collapse();
        return this;
    }
    expand() {
        if (!this.collapsed.value())
            return this;
        this.expanded_event.trigger(undefined);
        this.collapsed.set(false);
        return this;
    }
    collapse() {
        if (this.collapsed.value())
            return this;
        this.collapsed_event.trigger(undefined);
        this.collapsed.set(true);
        return this;
    }
    onCollapse(f) {
        this.collapsed_event.on(f);
        return this;
    }
    setCollapsed(collapsed) {
        if (this.isCollapsed()) {
            if (!collapsed)
                this.expand();
        }
        else {
            if (collapsed)
                this.collapse();
        }
        return this;
    }
    onExpansion(f) {
        this.expanded_event.on(f);
        return this;
    }
    state() {
        return this.collapsed;
    }
    onChange(f, trigger_now = false) {
        this.state().subscribe(f, trigger_now);
        return this;
    }
}
(function (ExpansionBehaviour) {
    function create(options) {
        let behaviour = new ExpansionBehaviour(!!options.starts_collapsed)
            .onCollapse(() => options.onCollapse(options.target))
            .onExpansion(() => options.onExpand(options.target));
        if (options.collapse_button)
            behaviour.bindToClickable(options.collapse_button);
        if (options.target && options.starts_collapsed) {
            options.target.container.css({ "display": "none" });
        }
        return behaviour;
    }
    ExpansionBehaviour.create = create;
    function horizontal(options) {
        return create({
            target: options.target,
            starts_collapsed: options.starts_collapsed,
            onExpand: (target) => target.container.animate({ "width": "show" }, options.duration || 300),
            onCollapse: (target) => target.container.animate({ "width": "hide" }, options.duration || 300),
        });
    }
    ExpansionBehaviour.horizontal = horizontal;
    function vertical(options) {
        return create({
            target: options.target,
            starts_collapsed: options.starts_collapsed,
            onExpand: (target) => target.container.animate({ "height": "show" }, options.duration || 300),
            onCollapse: (target) => target.container.animate({ "height": "hide" }, options.duration || 300),
        });
    }
    ExpansionBehaviour.vertical = vertical;
})(ExpansionBehaviour || (ExpansionBehaviour = {}));
